import React from 'react';
import Button from '@material-ui/core/Button';
import InboxItemActionButtons from './inbox-item-action-buttons/InboxItemActionButtons';
import {List} from 'immutable';
import {browserHistory} from 'react-router';
import {getStringQueryParam} from 'utils/getQueryParam';
import {LeftArrowLong} from '@components/icon/LeftArrowLong';

/**
 * see GenericHeader - similar back button behavior
 */
export default class ViewItemToolbar extends React.PureComponent {
  constructor(props) {
    super(props);

    this.goBack = this.goBack.bind(this);
  }

  goBack() {
    const {location} = this.props;

    if (getStringQueryParam(location, 'fromEmail')) {
      browserHistory.push('/inbox');
    } else {
      browserHistory.goBack();
    }
  }

  render() {
    const {inboxItem, children} = this.props;

    return (
      <div className="mail-toolbar">
        <div className="view-item-wrapper">
          <div className="view-item-buttons">
            <Button variant="text" className="ev-button" onClick={this.goBack}>
              <LeftArrowLong /> Back
            </Button>
            {inboxItem && (
              <InboxItemActionButtons
                targets={List([inboxItem])}
                areAllSelected={false}
                {...this.props}
              />
            )}
          </div>
          {children}
        </div>
      </div>
    );
  }
}
